//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'position',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    showObj: function showObj() {
      var _this$value$config = this.value.config,
        _this$value$config$po = _this$value$config.position_show,
        position_show = _this$value$config$po === void 0 ? true : _this$value$config$po,
        _this$value$config$ba = _this$value$config.back_button_show,
        back_button_show = _this$value$config$ba === void 0 ? false : _this$value$config$ba;
      return {
        position_show: position_show,
        back_button_show: back_button_show
      };
    },
    Styles: function Styles() {
      var _this$value$config2 = this.value.config,
        _this$value$config2$b = _this$value$config2.back_size,
        back_size = _this$value$config2$b === void 0 ? 20 : _this$value$config2$b,
        _this$value$config2$b2 = _this$value$config2.back_color,
        back_color = _this$value$config2$b2 === void 0 ? '#c20c0c' : _this$value$config2$b2,
        _this$value$config2$i = _this$value$config2.icon_font_size,
        icon_font_size = _this$value$config2$i === void 0 ? 40 : _this$value$config2$i,
        _this$value$config2$i2 = _this$value$config2.icon_color,
        icon_color = _this$value$config2$i2 === void 0 ? '#c20c0c' : _this$value$config2$i2,
        _this$value$config2$f = _this$value$config2.font_size,
        font_size = _this$value$config2$f === void 0 ? 28 : _this$value$config2$f,
        _this$value$config2$c = _this$value$config2.color,
        color = _this$value$config2$c === void 0 ? '#c20c0c' : _this$value$config2$c,
        _this$value$config2$e = _this$value$config2.enter_icon_font_size,
        enter_icon_font_size = _this$value$config2$e === void 0 ? 20 : _this$value$config2$e,
        _this$value$config2$e2 = _this$value$config2.enter_icon_color,
        enter_icon_color = _this$value$config2$e2 === void 0 ? '#c20c0c' : _this$value$config2$e2;
      var baseSize = 32; //基准值 16*2 C端即可直接取值

      var backIconFontSize = back_size / baseSize;
      var iconFontSize = icon_font_size / baseSize;
      var fontSize = font_size / baseSize;
      var enterIconFontSize = enter_icon_font_size / baseSize;
      return {
        '--backIconFontSize': backIconFontSize + 'rem',
        '--backIconColor': back_color || '#c20c0c',
        '--iconFontSize': iconFontSize + 'rem',
        '--iconColor': icon_color || '#c20c0c',
        '--fontSize': fontSize + 'rem',
        '--color': color || '#c20c0c',
        '--enterIconFontSize': enterIconFontSize + 'rem',
        '--enterIconColor': enter_icon_color || '#c20c0c'
      };
    }
  }
};